import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { Swiper, SwiperSlide } from 'swiper/react'
import type { Swiper as SwiperClass } from 'swiper/types'
import { Slide } from 'ui/preview/Carousel/Slide'
import { preview } from 'ui/preview/store/PreviewStore'
import css from './Carousel.module.scss'
import 'swiper/css'

const Carousel = observer(() => {
  const { inferences, index } = preview.it
  const [swiper, setSwiper] = useState<SwiperClass>()

  useEffect(() => {
    if (swiper) swiper.slideTo(index)
  }, [index])

  const onActiveIndexChange = useLatestCallback((swiper: SwiperClass) => {
    preview.it.index = swiper.activeIndex
  })

  return <div className={css.carousel}>
    <Swiper initialSlide={index} speed={200} grabCursor={true}
      onSwiper={setSwiper} onActiveIndexChange={onActiveIndexChange}>
      {inferences.map(it => <SwiperSlide key={it.inference_id}>
        <Slide inference={it} />
      </SwiperSlide>)}
    </Swiper>
  </div>
})

export function createCarousel(): [HTMLDivElement, Function] {
  const element = document.createElement('div')
  const root = createRoot(element)
  root.render(<Carousel />)

  function unmount() {
    root.unmount()
  }

  return [element, unmount]
}
